// extracted by extract-css-chunks-webpack-plugin
module.exports = {"categoryListView":"qJkjLh","listWrapper":"_10uU-d","listItem":"_2vFBdi"};